export default "__VITE_ASSET__DTx$Mvxx__"